export const offset = (currentPage: number, pageSize: number): number => {
  if (pageSize <= 0 || currentPage <= 0) return 0;
  return (currentPage - 1) * pageSize;
};
export const canLoadMore = (totalCurrData: number, totalData: number): boolean => {
  return totalCurrData < totalData;
};